import { NgModule } from "@angular/core";
import { ExpressionBuilderFormComponent } from './expression-builder-form/expression-builder-form.component';
import { DynamicExpressionBuilderComponent } from './dynamic-expression-builder.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ExpressionBuilderDesignComponent } from './expression-builder-design/expression-builder-design.component';
import { QueryBuilderModule } from "angular2-query-builder";
import { ExpressionBuilderService } from './expression-builder.service';
import { MaterialModule } from '../../material.module';

@NgModule({
    declarations: [
        ExpressionBuilderDesignComponent, ExpressionBuilderFormComponent, DynamicExpressionBuilderComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        QueryBuilderModule,
        MaterialModule
    ],
    exports: [
        ExpressionBuilderFormComponent
    ],
    entryComponents: [
        DynamicExpressionBuilderComponent
    ],
    providers: [
        ExpressionBuilderService
    ]
})
export class ExpressionBuilderModule {}